import { defineStore } from "pinia";
import { ref } from "vue";

export interface BreadcrumbItem {
	title: string;
	disabled: boolean;
	to: string;
}

export const useCampaignPlannerStore = defineStore("useCampaignPlannerStore", () => {
	const breadcrumbs = ref<BreadcrumbItem[]>([]);

	const truncate = (title: string, max = 20) =>
		title.length > max ? title.slice(0, max) + "…" : title;

	const setBreadcrumbs = (items: BreadcrumbItem[]) => {
		breadcrumbs.value = items.map((item) => ({
			...item,
			title: truncate(item.title),
		}));
	};

	return { breadcrumbs, setBreadcrumbs };
});
